import { render } from "./App.vue?vue&type=template&id=91f33382&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=91f33382&lang=less"

import exportComponent from "E:\\project\\ale\\建大车辆入校预约\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__